<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="15"
    height="10"
    viewBox="0 0 15 10"
  >
    <g
      id="Comments_icon_mobile_"
      data-name="Comments icon (mobile)"
      transform="translate(0.5 0.5)"
    >
      <line
        id="Line_367"
        data-name="Line 367"
        x2="6"
        transform="translate(5.001 3)"
        fill="none"
        stroke="#7d8296"
        stroke-width="1"
      />
      <line
        id="Line_368"
        data-name="Line 368"
        x2="4"
        transform="translate(5.001 6)"
        fill="none"
        stroke="#7d8296"
        stroke-width="1"
      />
      <path
        id="Union_5"
        data-name="Union 5"
        d="M3.789,9a1,1,0,0,1-1-1V2.667L.788,0h13a1,1,0,0,1,1,1V8a1,1,0,0,1-1,1Z"
        transform="translate(-0.788)"
        fill="none"
        stroke="#7d8296"
        stroke-linejoin="round"
        stroke-width="1"
      />
      <path
        id="Path_1992"
        data-name="Path 1992"
        d="M0,0"
        transform="translate(8.698 6.311) rotate(-90)"
        fill="none"
        stroke="#7d8296"
        stroke-width="1"
      />
    </g>
  </svg>
</template>

<script>
export default {
  name: 'Comments',
}
</script>

<style lang="scss" scoped></style>
